<footer class="footer-dash-user resize-pd-footer" style="">

  <div class="row">
    <div class="col-md-7">
      Copyright © AFHunt Group 2020
      Made with <span class="fa fa-heart" style="color: #ff5406;"></span> by <a href="https://code.afhunt.com" style="color: #ff5406;" target="_blank">AFH Code</a>
    </div>

    <div class="col-md-5 text-right">
      <a href="javascript:void(0)" routerLink="/public/cgu">CGU</a> | <a href="javascript:void(0)" routerLink="/public/confidentialite">Confidentialité</a> | <a href="#">Aide</a>
    </div>
  </div>
</footer>
